var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import * as pako from "pako";
import ImageCollector from "../types/ImageCollector";
import { CollectorId } from "../types";
import ApiErrorReason from "../../../src/types/ApiErrorReason";
class SnapshotsCollector extends ImageCollector {
    constructor(options, plasm) {
        super(options, plasm);
        this.state = {
            isShotsLimitReached: false,
        };
        const { snapshotWidth, snapshotHeight, snapshotQuality } = plasm.config;
        this.id = CollectorId.camera;
        this.IMAGE_DIMENSIONS = { width: snapshotWidth, height: snapshotHeight };
        this.IMAGE_QUALITY = snapshotQuality;
    }
    setupStream() {
        return __awaiter(this, void 0, void 0, function* () {
            this.stream = yield navigator.mediaDevices.getUserMedia({ audio: false, video: true });
            this.video.srcObject = this.stream;
            return new Promise((resolve) => {
                this.video.oncanplay = () => resolve();
            });
        });
    }
    buildSetupMeta() {
        return { stream: this.stream };
    }
    sendImage(image, shotData) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            const { trigger } = shotData;
            const { sessionUuid } = this.plasm;
            const authToken = this.plasm.options.clientToken;
            const compressedImage = new Blob([pako.gzip(new Uint8Array(image))], {
                type: "application/octet-stream",
            });
            const extraData = yield this.generateExtraData();
            const url = `${this.plasm.options.plasmApiUrl}/snapshots`;
            const headers = { Authorization: `Bearer ${authToken}` };
            const data = {
                sessionUuid,
                trigger,
                image: compressedImage,
                extraData,
            };
            try {
                yield axios.postForm(url, data, { headers });
                this.plasm.debug(`snapshot sent. trigger: ${trigger}`);
            }
            catch (err) {
                const errorReason = (_d = (_c = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.details) === null || _d === void 0 ? void 0 : _d.reason;
                switch (errorReason) {
                    case ApiErrorReason.SESSION_SNAPSHOTS_LIMIT_REACHED: {
                        this.plasm.debug("session snapshots limit reached");
                        this.state.isShotsLimitReached = true;
                        yield this.stop();
                        break;
                    }
                    case ApiErrorReason.SESSION_EXPIRED:
                        yield this.plasm.stop();
                        break;
                    default:
                        throw err;
                }
            }
        });
    }
}
export default SnapshotsCollector;
